import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';

@Injectable({
  providedIn: 'root'
})
export class ManualUploadDownloadService {

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }

  // TODO: update qa/prod URLs in environment files when backend deploys to those stages
  private get s9BaseUrl(): string {
    return this.environment.commonS9RestUrl;
  }

  private getHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('Ebom_accessToken') || '',
        'x-api-key': localStorage.getItem('Filename') || ''
      })
    };
  }

  /**
   * List latest 5 files for the selected download type.
   * POST /getBomStruBeanList/{proxy+}  (BOM_STRUCTURE)
   * POST /getmonthlyRepProd/{proxy+}   (MONTHLY_REPORT)
   * Body without downloadFileName → returns file list
   */
  getS3FileList(downloadType: string): Observable<any> {
    const httpOptions = this.getHttpOptions();
    const fileName = localStorage.getItem('Filename') || '';
    const body = {
      mailId: localStorage.getItem('emailId') || '',
      screenNo: 'NBPC_10116',
      fileName
    };
    const url = downloadType === 'BOM_STRUCTURE'
      ? `${this.s9BaseUrl}/getManualDownloadBomStruList/list?screenNo=NBPC_10116&fileName=${fileName}`
      : `${this.s9BaseUrl}/getManualDownloadMonthlyRep/list?screenNo=NBPC_10116&fileName=${fileName}`;
    return this.http.post(url, body, httpOptions).pipe(map((res: any) => res));
  }

  /**
   * Get a pre-signed download URL for a specific file.
   * Same endpoints but body includes downloadFileName → returns presigned URL
   */
  downloadFile(downloadType: string, downloadFileName: string): Observable<any> {
    const httpOptions = this.getHttpOptions();
    const fileName = localStorage.getItem('Filename') || '';
    const body = {
      mailId: localStorage.getItem('emailId') || '',
      screenNo: 'NBPC_10116',
      fileName,
      downloadFileName
    };
    const url = downloadType === 'BOM_STRUCTURE'
      ? `${this.s9BaseUrl}/getManualDownloadBomStruList/download?screenNo=NBPC_10116&fileName=${fileName}`
      : `${this.s9BaseUrl}/getManualDownloadMonthlyRep/download?screenNo=NBPC_10116&fileName=${fileName}`;
    return this.http.post(url, body, httpOptions).pipe(map((res: any) => res));
  }

  /**
   * Upload a file via the manualUploadFile Lambda.
   * POST /manualUploadFile/{proxy+}  — multipart/form-data
   * fileHash (optional SHA-256 of content) lets the backend reject duplicate uploads.
   */
  uploadFile(uploadType: string, file: File, fileHash?: string): Observable<any> {
    const fileName = localStorage.getItem('Filename') || '';
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('uploadType', uploadType);
    formData.append('mailId', localStorage.getItem('emailId') || '');
    formData.append('screenNo', 'NBPC_10116');
    if (fileHash) { formData.append('fileHash', fileHash); }
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': localStorage.getItem('Ebom_accessToken') || '',
        'x-api-key': localStorage.getItem('Filename') || ''
      })
    };
    return this.http.post(
      `${this.s9BaseUrl}/manualUploadFileToS3/upload?screenNo=NBPC_10116&fileName=${fileName}`,
      formData, httpOptions);
  }

  getUploadTemplate(uploadType: string): Observable<any> {
    const fileName = localStorage.getItem('Filename') || '';
    const url = `${this.s9BaseUrl}/getManualUploadTemplate/get?screenNo=NBPC_10116&fileName=${fileName}&uploadType=${uploadType}`;
    return this.http.get(url, this.getHttpOptions()).pipe(map((res: any) => res));
  }
}

